export default "__VITE_ASSET__BefXlHPZ__"